import cn from 'classnames'

import TipOption from 'components/TipConfigurations/TipOption'

const TipOptions = ({
  options,
  isOther,
  handleSaveTipOption,
  showError,
  errorMessage,
  handleSetName,
  isHeaderBold = false,
}) => {
  return (
    <section className="content-wrapper -block -flags-wrapper">
      <h3
        className={cn('header-title -margin-bottom-xxs', {
          '-font-regular': !isHeaderBold,
        })}
      >
        Tip Options
      </h3>
      <p className="description">
        A minimum of two and maximum of five tip options are
        supported.
      </p>
      <div className="content-wrapper min-height-60 color-disabled">
        <span className="content-header">Tip Option 1</span>
        <span className="content-value">No Tip</span>
      </div>
      {options?.map((option, index) => {
        const header = `Tip Option ${index + 2}`

        const isLast = options.length - 1 === index

        return (
          <TipOption
            value={option}
            handleSaveTipOption={(value) =>
              handleSaveTipOption(value, index)
            }
            isOther={isLast ? isOther : false}
            index={index}
            key={index}
            name={handleSetName(index)}
            header={header}
          />
        )
      })}

      {showError && (
        <div className="textbox__error-msg">{errorMessage}</div>
      )}
    </section>
  )
}

export default TipOptions
